import { Component } from '@angular/core';

import { HomePage } from '../home/home';
import { FeedingPage } from "../feeding/feeding";
import { DiapersPage } from "../diapers/diapers";

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  tab1Root = HomePage;
  tab2Root = FeedingPage;
  tab3Root = DiapersPage;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts